module.exports = __webpack_public_path__ + "static/media/workspacde.ee1e8fec.png";